<div class="mat-dialog-container">
  <!-- 明細編輯開始 -->
  <div #head>
    <app-modal-header #modal_header [isDialog]="isDialog" [title]="title" [state]="srv.state" (onOkClick)="doOk($event)"
      (onEditAndSaveClick)="doEditAndSave($event)"
      (onCancelClick)="doCancel($event)">
    </app-modal-header>
  </div>
  <div class="jk-content">
    <div > 
    <app-jkedit  label="公司電話(一)" #MB023Com  id="MB023"  [(value)]="item.MB023" placeholder="公司電話(一)"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="個人郵遞區號" #MB017Com  id="MB017"  [(value)]="item.MB017" placeholder="個人郵遞區號"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="個人網址" #MB018Com  id="MB018"  [(value)]="item.MB018" placeholder="個人網址"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="照片檔名" #MB019Com  id="MB019"  [(value)]="item.MB019" placeholder="照片檔名"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jktextarea  height="250px" 
 label="備註" #MB020Com  id="MB020"  [(value)]="item.MB020" placeholder="備註"  [readonly]="isBrowse"     >
    </app-jktextarea>
    <app-jkedit  label="公司地址" #MB021Com  id="MB021"  [(value)]="item.MB021" placeholder="公司地址"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="公司郵遞區號" #MB022Com  id="MB022"  [(value)]="item.MB022" placeholder="公司郵遞區號"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="個人地址" #MB016Com  id="MB016"  [(value)]="item.MB016" placeholder="個人地址"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="公司傳真號碼" #MB024Com  id="MB024"  [(value)]="item.MB024" placeholder="公司傳真號碼"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="公司E-MAIL" #MB025Com  id="MB025"  [(value)]="item.MB025" placeholder="公司E-MAIL"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="暱稱" #MB026Com  id="MB026"  [(value)]="item.MB026" placeholder="暱稱"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="客戶代號" #MB027Com  id="MB027"  [(value)]="item.MB027" placeholder="客戶代號"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="廠商代號" #MB028Com  id="MB028"  [(value)]="item.MB028" placeholder="廠商代號"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="部門名稱" #MB029Com  id="MB029"  [(value)]="item.MB029" placeholder="部門名稱"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jktextarea  height="250px" 
 label="附註" #MB030Com  id="MB030"  [(value)]="item.MB030" placeholder="附註"  [readonly]="isBrowse"     >
    </app-jktextarea>
    <app-jkedit  label="流水號" #MB001Com  id="MB001"  [(value)]="item.MB001" [required]="true"  placeholder="流水號"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="個人電話(二)" #MB008Com  id="MB008"  [(value)]="item.MB008" placeholder="個人電話(二)"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="擁有者" #MB002Com  id="MB002"  [(value)]="item.MB002" placeholder="擁有者"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="姓名" #MB003Com  id="MB003"  [(value)]="item.MB003" placeholder="姓名"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="職務" #MB004Com  id="MB004"  [(value)]="item.MB004" placeholder="職務"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkcombobox  label="性別" #MB005Com  id="MB005"  [(value)]="item.MB005" [items]="srv.MtrMb005List"  [readonly]="isBrowse"     >
    </app-jkcombobox>
    <app-jkedit  label="公司" #MB006Com  id="MB006"  [(value)]="item.MB006" placeholder="公司"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="個人電話(一)" #MB007Com  id="MB007"  [(value)]="item.MB007" placeholder="個人電話(一)"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkdatefield  label="生日" #MB015Com  id="MB015"  [(value)]="item.MB015" placeholder="生日"  [readonly]="isBrowse" 
            >
    </app-jkdatefield>
    <app-jkedit  label="手機" #MB009Com  id="MB009"  [(value)]="item.MB009" placeholder="手機"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="個人傳真號碼" #MB010Com  id="MB010"  [(value)]="item.MB010" placeholder="個人傳真號碼"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="個人E-MAIL" #MB011Com  id="MB011"  [(value)]="item.MB011" placeholder="個人E-MAIL"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="部門別" #MB012Com  id="MB012"  [(value)]="item.MB012" placeholder="部門別"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="通路別" #MB013Com  id="MB013"  [(value)]="item.MB013" placeholder="通路別"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="地區別" #MB014Com  id="MB014"  [(value)]="item.MB014" placeholder="地區別"  [readonly]="isBrowse"     >
    </app-jkedit>

    </div>
  </div>
</div>